/* kitsters-blog.js - Blog list: scroll-reveal + tag slider toggle */
(function () {
  'use strict';

  /* ── 1. Scroll-reveal (IntersectionObserver) ──────────────────────
     Cards start at opacity:0. Observer makes them visible once they
     enter the viewport. Threshold 0 = trigger on first pixel visible,
     which prevents cards from being stuck as blank spaces.
  ─────────────────────────────────────────────────────────────────── */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealTargets = document.querySelectorAll('.kb__reveal');
    if (revealTargets.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px 0px 60px 0px'   /* pre-reveal slightly before they scroll in */
        }
      );
      revealTargets.forEach(function (el) { io.observe(el); });
    }
  } else {
    /* Reduced-motion: immediately show all cards so grid has no blank spaces */
    document.querySelectorAll('.kb__reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ── 2. Tag slider "Show all / Show less" toggle ──────────────────
     Finds every .kb__tabs-toggle on the page and wires up the
     expand/collapse behaviour for its sibling .kb__tabs-inner.
  ─────────────────────────────────────────────────────────────────── */
  document.querySelectorAll('.kb__tabs-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.kb__tabs');
      if (!nav) return;

      var expanded = nav.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded
        ? (btn.dataset.labelLess || 'Show less')
        : (btn.dataset.labelMore || 'Show all');
    });
  });

  /* ── 3. All-blogs index: topic filter + Show more ─────────────────
     The index renders EVERY article from every source blog in one grid
     (Liquid cannot paginate a merged array - see the section's header
     comment), so visibility is managed here instead of by pagination.

     One render() owns both concerns. Filtering and revealing are the
     same question - "which cards should be on screen right now?" - and
     splitting them into two functions is how the count and the button
     drift out of sync with the grid.
  ─────────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-blog-index]').forEach(function (root) {
    var grid = root.querySelector('[data-blog-grid]');
    if (!grid) return;

    var cards    = Array.prototype.slice.call(grid.querySelectorAll('.post[data-blog]'));
    var moreBtn  = root.querySelector('[data-blog-more]');
    var moreNum  = root.querySelector('[data-blog-more-count]');
    var shownNum = root.querySelector('[data-blog-count-shown]');
    var countEl  = root.querySelector('[data-blog-count]');
    var tabs     = Array.prototype.slice.call(root.querySelectorAll('.kb__tab[data-filter]'));

    var batch  = parseInt(root.dataset.batch, 10) || 12;
    var filter = 'all';
    var shown  = batch;

    function render() {
      var matched = 0;
      cards.forEach(function (card) {
        var isMatch = filter === 'all' || card.dataset.blog === filter;
        if (!isMatch) {
          card.classList.add('post--extra');
          return;
        }
        matched++;
        card.classList.toggle('post--extra', matched > shown);
      });

      var visible   = Math.min(shown, matched);
      var remaining = matched - visible;

      if (moreBtn) {
        moreBtn.hidden = remaining === 0;
        if (moreNum) moreNum.textContent = '(' + remaining + ')';
      }
      if (countEl) {
        countEl.hidden = matched === 0;
        if (shownNum) shownNum.textContent = String(visible);
        /* The total moves with the filter, so rewrite the whole sentence
           rather than only the leading number. */
        var totalNode = countEl.lastChild;
        if (totalNode && totalNode.nodeType === 3) {
          totalNode.textContent = ' of ' + matched + ' posts';
        }
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shown += batch;
        render();
        /* Move focus to the first newly revealed card so keyboard and
           screen-reader users land on the new content, not back at the top. */
        var firstNew = cards.filter(function (c) { return !c.classList.contains('post--extra'); })
                            .slice(-1)[0];
        var link = firstNew && firstNew.querySelector('.post__title a');
        if (link) link.focus({ preventScroll: true });
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        /* Each chip is a real link to that blog's own page - that is the
           no-JS fallback. With JS we filter in place instead. */
        e.preventDefault();
        filter = tab.dataset.filter || 'all';
        shown  = batch;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('active', on);
          if (on) { t.setAttribute('aria-current', 'page'); }
          else    { t.removeAttribute('aria-current'); }
        });
        render();
      });
    });

    render();
  });

})();
